import React from 'react';
import ModalProvider from '../../Contexts/Modal/modal.provider';
import { ToastProvider } from '../../Contexts/Toast/toast.provider';

const GlobalModule = ({ children }) => {
  return (
    <>
      <ToastProvider>
        <ModalProvider>
          {children} 
        </ModalProvider>
      </ToastProvider>
    </>
  )
}

export default GlobalModule